// src/App.js
import React, { useState } from 'react';
import WordSearchConfig from './components/searchwords/WordSearchConfig';
import WordSearchGame from './components/searchwords/WordSearchGame';
import { HashRouter, Routes, Route, useNavigate, Link } from 'react-router-dom';
import MainCrossword from './components/crosswords/main';
import ConfigScreen from './components/crosswords/config';
import { LoginScreen } from './components/auth/login';
import Navigationbar from './components/nav/nav';
import { Footer } from './components/nav/footer';
import { RegisterScreen } from './components/auth/register';
import { RankingsScreen } from './components/ranked/list';
import RankingConfigScreen from './components/ranked/RankedConfig';
import RankingCrossword from './components/ranked/RankedCrossword';
import RankingHistory from './components/main/RankedHistory';
import SettingsScreen from './components/main/settings';
import { ChooseUsernameScreen } from './components/auth/ChooseUsernameScreen';
import HomeScreen from "./components/main/HomeScreen"
import PrivacyPolicy from './components/main/PrivacyPolicy';




export default function App() {
    return (
        <HashRouter>
            <div style={styles.appLayout}>
                <Navigationbar />
                <main style={styles.mainContent}>
                    <Routes>

                        <Route path="/wordsearch-config" element={<WordSearchConfig />} />
                        <Route path="/crossword-config" element={<ConfigScreen />} />
                        <Route path="/wordsearch" element={<WordSearchGame />} />
                        <Route path="/choose-username" element={<ChooseUsernameScreen />} />
                        <Route path="/" element={<HomeScreen/>} />
                        <Route path="/home" element={<ConfigScreen />} />
                        <Route path="/login" element={<LoginScreen />} />
                        <Route path="/register" element={<RegisterScreen />} />
                        <Route path="/ranking" element={<RankingsScreen />} />

                        <Route path="/crossword" element={<MainCrossword />} />
                        <Route path="/history" element={<RankingHistory />} />
                        <Route path="/settings" element={<SettingsScreen />} />
                        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                        

                    </Routes>
                </main>
                <Footer />
            </div>
        </HashRouter>
    );
}

// --- STYLE ---

const styles = {
    appLayout: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #a4a5ff 0%, #8cb8ff 100%)',
        fontFamily: "'Segoe UI', Roboto, sans-serif",
    },
    navbar: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '15px 40px',
        backgroundColor: 'rgba(255, 255, 255, 0.9)',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
        position: 'sticky',
        top: 0,
        zIndex: 1000
    },
    navLogo: {
        fontSize: '22px',
        fontWeight: 'bold',
        color: '#1e293b',
        textDecoration: 'none'
    },
    navLinks: {
        display: 'flex',
        gap: '20px',
        alignItems: 'center'
    },
    navLink: {
        textDecoration: 'none',
        color: '#64748b',
        fontWeight: '500',
        transition: 'color 0.2s'
    },
    loginBtn: {
        textDecoration: 'none',
        backgroundColor: '#2563eb',
        color: 'white',
        padding: '8px 18px',
        borderRadius: '8px',
        fontWeight: '600',
        transition: 'transform 0.2s'
    },
    mainContent: {
        flex: 1, // To sprawia, że footer zawsze jest na dole
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '20px'
    },
    footer: {
        textAlign: 'center',
        padding: '20px',
        backgroundColor: 'rgba(0, 0, 0, 0.05)',
        color: '#1e293b',
        fontSize: '14px'
    },
    screenWrapper: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    card: {
        backgroundColor: '#ffffff',
        borderRadius: '20px',
        boxShadow: '0 15px 35px rgba(0, 0, 0, 0.1)',
        width: '100%',
        maxWidth: '400px',
        padding: '35px',
        boxSizing: 'border-box'
    },
    header: { textAlign: 'center', marginBottom: '25px' },
    title: { margin: '0 0 10px 0', fontSize: '26px', color: '#0f172a', fontWeight: '800' },
    subtitle: { margin: '0', fontSize: '15px', color: '#64748b' },
    form: { display: 'flex', flexDirection: 'column', gap: '18px' },
    inputGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontWeight: '600', fontSize: '13px', color: '#475569' },
    input: {
        padding: '12px',
        fontSize: '16px',
        borderRadius: '10px',
        border: '2px solid #e2e8f0',
        backgroundColor: '#f8fafc',
        outline: 'none'
    },
    button: {
        padding: '14px',
        fontSize: '17px',
        fontWeight: 'bold',
        backgroundColor: '#2563eb',
        color: 'white',
        border: 'none',
        borderRadius: '10px',
        cursor: 'pointer',
        transition: 'background 0.2s'
    }
};